module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Pessoa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Para adicionar um membro da equipe, realize a pesquisa pelo nome ou CPF da pessoa. Caso a pessoa desejada não seja encontrada, \n                clique no botão \"CADASTRAR MEMBRO EXTERNO\".\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.tipoBusca),
      callback: function($$v) {
        _vm.tipoBusca = $$v
      },
      expression: "tipoBusca"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Nome",
      "value": "nome"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "CPF",
      "value": "cpf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca === 'nome'),
      expression: "tipoBusca==='nome'"
    }],
    attrs: {
      "label": "Nome",
      "max-height": "400"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorNome()
      }
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  }), _vm._v(" "), _c('v-text-field-cpf', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca !== 'nome'),
      expression: "tipoBusca!=='nome'"
    }],
    attrs: {
      "label": "CPF",
      "options": {
        outputMask: '###.###.###-##',
      }
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorCpf()
      }
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs3": ""
    }
  }, [(_vm.tipoBusca === 'nome') ? _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaPessoasPorNome()
      }
    }
  }, [_vm._v("Pesquisar")]) : _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaPessoasPorCpf()
      }
    }
  }, [_vm._v("Pesquisar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaPessoas,
      "search": _vm.search,
      "no-data-text": 'Nenhuma pessoa encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "primary",
            "tooltip": "Adicionar como membro da equipe"
          },
          on: {
            "click": function($event) {
              return _vm.toAdicionarMembroEquipe(props.item.idPessoa)
            }
          }
        })]
      }
    }, {
      key: "item.cpf",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.cpf === null || props.item.cpf === '' ? '-' : props.item.cpf))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaPessoas.length) + " " + _vm._s(_vm.listaPessoas.length > 1 ? 'pessoas' : 'pessoa') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cadastrarMembroExterno()
      }
    }
  }, [_vm._v("Cadastrar Membro Externo")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0000181b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/pesquisar-pessoas.vue
// module id = 839
// module chunks = 0